// Copy for co-tasting: what two or more people in a shared tasting see of each other (the
// live strip, the "Samen proeven" lobby strip, the switch that shares picks), what the group
// thought, the line a taster may say to the group, the solo-or-group choice and the home card of the
// next planned tasting. Our own words. One entry per locale; every key exists in all seven (nl is
// the source, the rest are translations).
export const togetherCopy = {
  nl: {
    "together.strip.title": "Samen proeven",
    "together.strip.invited": "{names} uitgenodigd",
    "together.strip.joined": "{names} doen mee",
    "together.strip.invite": "Nodig mensen uit om samen te proeven.",
    "together.strip.live": "notities live gedeeld",
    "together.strip.private": "je keuzes blijven van jou",
    "together.strip.blind": "blind: alleen je voortgang wordt gedeeld",
    "together.share.label": "Deel mijn keuzes live",
    "together.share.hint":
      "De anderen zien je aroma's, structuur en oordeel terwijl je kiest. Dit blijft in het geheugen en wordt nergens bewaard.",
    "together.share.blind":
      "Bij blind proeven zien de anderen alleen je voortgang, nooit je keuzes.",
    "together.live.region": "Wie er mee proeft",
    "together.live.at": "{name} is bij {where}",
    "together.live.atWine": "{name} is bij wijn {n}",
    "together.live.atWineStep": "{name} is bij wijn {n}, {step}",
    "together.live.waiting": "Nog niet te zien: {names}",
    "together.live.dot": "Live bijgewerkt",
    "together.live.private": "{name} houdt de keuzes voor zich",
    "together.live.nothing": "{name} heeft nog niets gekozen",
    "together.live.picksOf": "Keuzes van {name}",
    "together.group.title": "Wat de groep vond",
    "together.group.you": "jij",
    "together.group.median": "Middelste oordeel: {verdict}",
    "together.group.mode": "Meest gekozen: {verdict}",
    "together.group.hintOpen": "Lever je oordeel over deze wijn in om te zien wat de groep vond.",
    "together.group.hintBlind": "Na de onthulling zie je wat de groep vond.",
    "together.group.quote": "“{quote}”",
    "together.quote.label": "Zeg iets tegen de groep",
    "together.quote.hint":
      "Optioneel, tot {max} tekens. De groep ziet dit bij je oordeel; het wordt nooit uit je privénotitie gehaald.",
    "together.quote.placeholder": "Bijvoorbeeld: rozen, teer, lange afdronk",
    "together.quote.count": "{n} van {max}",
    "together.choice.label": "Hoe proef je?",
    "together.choice.solo": "Solo",
    "together.choice.group": "Met een groep",
    "together.choice.soloHint": "Alleen jij: niemand ziet wat je proeft.",
    "together.choice.groupHint":
      "Nodig mensen uit of deel een link; jullie zien elkaars keuzes live, als je dat wilt.",
    "together.tile.hint": "Solo of met een groep",
    "together.planned.eyebrow": "Gepland met vrienden",
    "together.planned.live": "Nu bezig",
    "together.planned.going": "{n} gaan mee",
    "together.planned.open": "Open {name}",
    "together.planned.join": "Naar de proeverij",
  },
  en: {
    "together.strip.title": "Tasting together",
    "together.strip.invited": "{names} invited",
    "together.strip.joined": "{names} are in",
    "together.strip.invite": "Invite people to taste together.",
    "together.strip.live": "notes shared live",
    "together.strip.private": "your picks stay yours",
    "together.strip.blind": "blind: only your progress is shared",
    "together.share.label": "Share my picks live",
    "together.share.hint":
      "The others see your aromas, structure and verdict as you choose them. It stays in memory and is not stored anywhere.",
    "together.share.blind":
      "In a blind tasting the others only see your progress, never your picks.",
    "together.live.region": "Who is tasting along",
    "together.live.at": "{name} is at {where}",
    "together.live.atWine": "{name} is at wine {n}",
    "together.live.atWineStep": "{name} is at wine {n}, {step}",
    "together.live.waiting": "Not seen yet: {names}",
    "together.live.dot": "Updated live",
    "together.live.private": "{name} keeps their picks to themselves",
    "together.live.nothing": "{name} has not picked anything yet",
    "together.live.picksOf": "{name}'s picks",
    "together.group.title": "What the group thought",
    "together.group.you": "you",
    "together.group.median": "Middle verdict: {verdict}",
    "together.group.mode": "Most chosen: {verdict}",
    "together.group.hintOpen": "Hand in your verdict on this wine to see what the group thought.",
    "together.group.hintBlind": "After the reveal you will see what the group thought.",
    "together.group.quote": "“{quote}”",
    "together.quote.label": "Say something to the group",
    "together.quote.hint":
      "Optional, up to {max} characters. The group sees this next to your verdict; it is never taken from your private note.",
    "together.quote.placeholder": "For example: roses, tar, long finish",
    "together.quote.count": "{n} of {max}",
    "together.choice.label": "How are you tasting?",
    "together.choice.solo": "Solo",
    "together.choice.group": "With a group",
    "together.choice.soloHint": "Just you: nobody sees what you taste.",
    "together.choice.groupHint":
      "Invite people or share a link; you see each other's picks live, if you like.",
    "together.tile.hint": "Solo or with a group",
    "together.planned.eyebrow": "Planned with friends",
    "together.planned.live": "Happening now",
    "together.planned.going": "{n} going",
    "together.planned.open": "Open {name}",
    "together.planned.join": "Go to the tasting",
  },
  de: {
    "together.strip.title": "Gemeinsam verkosten",
    "together.strip.invited": "{names} eingeladen",
    "together.strip.joined": "{names} sind dabei",
    "together.strip.invite": "Lade Leute ein, gemeinsam zu verkosten.",
    "together.strip.live": "Notizen live geteilt",
    "together.strip.private": "deine Auswahl bleibt bei dir",
    "together.strip.blind": "blind: nur dein Fortschritt wird geteilt",
    "together.share.label": "Meine Auswahl live teilen",
    "together.share.hint":
      "Die anderen sehen deine Aromen, Struktur und dein Urteil, während du wählst. Das bleibt im Speicher und wird nirgends gespeichert.",
    "together.share.blind":
      "Bei einer Blindverkostung sehen die anderen nur deinen Fortschritt, nie deine Auswahl.",
    "together.live.region": "Wer mitverkostet",
    "together.live.at": "{name} ist bei {where}",
    "together.live.atWine": "{name} ist bei Wein {n}",
    "together.live.atWineStep": "{name} ist bei Wein {n}, {step}",
    "together.live.waiting": "Noch nicht zu sehen: {names}",
    "together.live.dot": "Live aktualisiert",
    "together.live.private": "{name} behält die Auswahl für sich",
    "together.live.nothing": "{name} hat noch nichts gewählt",
    "together.live.picksOf": "Auswahl von {name}",
    "together.group.title": "Was die Gruppe fand",
    "together.group.you": "du",
    "together.group.median": "Mittleres Urteil: {verdict}",
    "together.group.mode": "Am häufigsten gewählt: {verdict}",
    "together.group.hintOpen":
      "Gib dein Urteil zu diesem Wein ab, um zu sehen, was die Gruppe fand.",
    "together.group.hintBlind": "Nach der Enthüllung siehst du, was die Gruppe fand.",
    "together.group.quote": "„{quote}“",
    "together.quote.label": "Sag der Gruppe etwas",
    "together.quote.hint":
      "Optional, bis zu {max} Zeichen. Die Gruppe sieht das neben deinem Urteil; es wird nie aus deiner privaten Notiz übernommen.",
    "together.quote.placeholder": "Zum Beispiel: Rosen, Teer, langer Abgang",
    "together.quote.count": "{n} von {max}",
    "together.choice.label": "Wie verkostest du?",
    "together.choice.solo": "Solo",
    "together.choice.group": "Mit einer Gruppe",
    "together.choice.soloHint": "Nur du: niemand sieht, was du verkostest.",
    "together.choice.groupHint":
      "Lade Leute ein oder teile einen Link; ihr seht eure Auswahl live, wenn du magst.",
    "together.tile.hint": "Solo oder mit einer Gruppe",
    "together.planned.eyebrow": "Geplant mit Freunden",
    "together.planned.live": "Läuft gerade",
    "together.planned.going": "{n} kommen",
    "together.planned.open": "{name} öffnen",
    "together.planned.join": "Zur Verkostung",
  },
  fr: {
    "together.strip.title": "Déguster ensemble",
    "together.strip.invited": "{names} invités",
    "together.strip.joined": "{names} participent",
    "together.strip.invite": "Invitez des personnes à déguster ensemble.",
    "together.strip.live": "notes partagées en direct",
    "together.strip.private": "vos choix restent les vôtres",
    "together.strip.blind": "à l'aveugle : seule votre progression est partagée",
    "together.share.label": "Partager mes choix en direct",
    "together.share.hint":
      "Les autres voient vos arômes, votre structure et votre verdict au fur et à mesure. Cela reste en mémoire et n'est enregistré nulle part.",
    "together.share.blind":
      "En dégustation à l'aveugle, les autres ne voient que votre progression, jamais vos choix.",
    "together.live.region": "Qui déguste avec vous",
    "together.live.at": "{name} est à {where}",
    "together.live.atWine": "{name} est au vin {n}",
    "together.live.atWineStep": "{name} est au vin {n}, {step}",
    "together.live.waiting": "Pas encore là : {names}",
    "together.live.dot": "Mis à jour en direct",
    "together.live.private": "{name} garde ses choix pour soi",
    "together.live.nothing": "{name} n'a encore rien choisi",
    "together.live.picksOf": "Choix de {name}",
    "together.group.title": "Ce que le groupe en a pensé",
    "together.group.you": "vous",
    "together.group.median": "Verdict médian : {verdict}",
    "together.group.mode": "Le plus choisi : {verdict}",
    "together.group.hintOpen":
      "Rendez votre verdict sur ce vin pour voir ce que le groupe en a pensé.",
    "together.group.hintBlind": "Après la révélation, vous verrez ce que le groupe en a pensé.",
    "together.group.quote": "« {quote} »",
    "together.quote.label": "Dites un mot au groupe",
    "together.quote.hint":
      "Facultatif, jusqu'à {max} caractères. Le groupe le voit à côté de votre verdict ; il n'est jamais tiré de votre note privée.",
    "together.quote.placeholder": "Par exemple : rose, goudron, longue finale",
    "together.quote.count": "{n} sur {max}",
    "together.choice.label": "Comment dégustez-vous ?",
    "together.choice.solo": "Seul",
    "together.choice.group": "En groupe",
    "together.choice.soloHint": "Vous seul : personne ne voit ce que vous dégustez.",
    "together.choice.groupHint":
      "Invitez des personnes ou partagez un lien ; vous voyez les choix des autres en direct, si vous le souhaitez.",
    "together.tile.hint": "Seul ou en groupe",
    "together.planned.eyebrow": "Prévu avec des amis",
    "together.planned.live": "En cours",
    "together.planned.going": "{n} viennent",
    "together.planned.open": "Ouvrir {name}",
    "together.planned.join": "Aller à la dégustation",
  },
  es: {
    "together.strip.title": "Catar juntos",
    "together.strip.invited": "{names} invitados",
    "together.strip.joined": "{names} participan",
    "together.strip.invite": "Invita a gente a catar juntos.",
    "together.strip.live": "notas compartidas en directo",
    "together.strip.private": "tus elecciones son solo tuyas",
    "together.strip.blind": "a ciegas: solo se comparte tu progreso",
    "together.share.label": "Compartir mis elecciones en directo",
    "together.share.hint":
      "Los demás ven tus aromas, estructura y veredicto mientras eliges. Se queda en la memoria y no se guarda en ningún sitio.",
    "together.share.blind":
      "En una cata a ciegas los demás solo ven tu progreso, nunca tus elecciones.",
    "together.live.region": "Quién cata contigo",
    "together.live.at": "{name} está en {where}",
    "together.live.atWine": "{name} está en el vino {n}",
    "together.live.atWineStep": "{name} está en el vino {n}, {step}",
    "together.live.waiting": "Aún sin conexión: {names}",
    "together.live.dot": "Actualizado en directo",
    "together.live.private": "{name} se guarda sus elecciones",
    "together.live.nothing": "{name} aún no ha elegido nada",
    "together.live.picksOf": "Elecciones de {name}",
    "together.group.title": "Lo que opinó el grupo",
    "together.group.you": "tú",
    "together.group.median": "Veredicto medio: {verdict}",
    "together.group.mode": "El más elegido: {verdict}",
    "together.group.hintOpen": "Entrega tu veredicto de este vino para ver lo que opinó el grupo.",
    "together.group.hintBlind": "Tras la revelación verás lo que opinó el grupo.",
    "together.group.quote": "«{quote}»",
    "together.quote.label": "Di algo al grupo",
    "together.quote.hint":
      "Opcional, hasta {max} caracteres. El grupo lo ve junto a tu veredicto; nunca se toma de tu nota privada.",
    "together.quote.placeholder": "Por ejemplo: rosas, alquitrán, final largo",
    "together.quote.count": "{n} de {max}",
    "together.choice.label": "¿Cómo catas?",
    "together.choice.solo": "Solo",
    "together.choice.group": "En grupo",
    "together.choice.soloHint": "Solo tú: nadie ve lo que catas.",
    "together.choice.groupHint":
      "Invita a gente o comparte un enlace; veis las elecciones de los demás en directo, si quieres.",
    "together.tile.hint": "Solo o en grupo",
    "together.planned.eyebrow": "Planeado con amigos",
    "together.planned.live": "En marcha",
    "together.planned.going": "{n} van",
    "together.planned.open": "Abrir {name}",
    "together.planned.join": "Ir a la cata",
  },
  it: {
    "together.strip.title": "Degustare insieme",
    "together.strip.invited": "{names} invitati",
    "together.strip.joined": "{names} partecipano",
    "together.strip.invite": "Invita qualcuno a degustare insieme.",
    "together.strip.live": "note condivise in diretta",
    "together.strip.private": "le tue scelte restano tue",
    "together.strip.blind": "alla cieca: si condivide solo il tuo avanzamento",
    "together.share.label": "Condividi le mie scelte in diretta",
    "together.share.hint":
      "Gli altri vedono i tuoi aromi, la struttura e il giudizio mentre scegli. Resta in memoria e non viene salvato da nessuna parte.",
    "together.share.blind":
      "In una degustazione alla cieca gli altri vedono solo il tuo avanzamento, mai le tue scelte.",
    "together.live.region": "Chi degusta con te",
    "together.live.at": "{name} è a {where}",
    "together.live.atWine": "{name} è al vino {n}",
    "together.live.atWineStep": "{name} è al vino {n}, {step}",
    "together.live.waiting": "Non ancora visibili: {names}",
    "together.live.dot": "Aggiornato in diretta",
    "together.live.private": "{name} tiene per sé le scelte",
    "together.live.nothing": "{name} non ha ancora scelto nulla",
    "together.live.picksOf": "Scelte di {name}",
    "together.group.title": "Cosa ne ha pensato il gruppo",
    "together.group.you": "tu",
    "together.group.median": "Giudizio mediano: {verdict}",
    "together.group.mode": "Il più scelto: {verdict}",
    "together.group.hintOpen":
      "Consegna il tuo giudizio su questo vino per vedere cosa ne ha pensato il gruppo.",
    "together.group.hintBlind": "Dopo la rivelazione vedrai cosa ne ha pensato il gruppo.",
    "together.group.quote": "«{quote}»",
    "together.quote.label": "Di' qualcosa al gruppo",
    "together.quote.hint":
      "Facoltativo, fino a {max} caratteri. Il gruppo lo vede accanto al tuo giudizio; non viene mai preso dalla tua nota privata.",
    "together.quote.placeholder": "Per esempio: rose, catrame, finale lungo",
    "together.quote.count": "{n} di {max}",
    "together.choice.label": "Come degusti?",
    "together.choice.solo": "Da solo",
    "together.choice.group": "In gruppo",
    "together.choice.soloHint": "Solo tu: nessuno vede cosa degusti.",
    "together.choice.groupHint":
      "Invita qualcuno o condividi un link; vedete le scelte degli altri in diretta, se vuoi.",
    "together.tile.hint": "Da solo o in gruppo",
    "together.planned.eyebrow": "In programma con gli amici",
    "together.planned.live": "In corso",
    "together.planned.going": "{n} vengono",
    "together.planned.open": "Apri {name}",
    "together.planned.join": "Vai alla degustazione",
  },
  pt: {
    "together.strip.title": "Provar juntos",
    "together.strip.invited": "{names} convidados",
    "together.strip.joined": "{names} participam",
    "together.strip.invite": "Convide pessoas para provar juntos.",
    "together.strip.live": "notas partilhadas em direto",
    "together.strip.private": "as tuas escolhas ficam contigo",
    "together.strip.blind": "às cegas: só o teu progresso é partilhado",
    "together.share.label": "Partilhar as minhas escolhas em direto",
    "together.share.hint":
      "Os outros veem os teus aromas, estrutura e veredicto enquanto escolhes. Fica na memória e não é guardado em lado nenhum.",
    "together.share.blind":
      "Numa prova às cegas os outros só veem o teu progresso, nunca as tuas escolhas.",
    "together.live.region": "Quem prova contigo",
    "together.live.at": "{name} está em {where}",
    "together.live.atWine": "{name} está no vinho {n}",
    "together.live.atWineStep": "{name} está no vinho {n}, {step}",
    "together.live.waiting": "Ainda sem sinal: {names}",
    "together.live.dot": "Atualizado em direto",
    "together.live.private": "{name} guarda as escolhas para si",
    "together.live.nothing": "{name} ainda não escolheu nada",
    "together.live.picksOf": "Escolhas de {name}",
    "together.group.title": "O que o grupo achou",
    "together.group.you": "tu",
    "together.group.median": "Veredicto mediano: {verdict}",
    "together.group.mode": "O mais escolhido: {verdict}",
    "together.group.hintOpen": "Entrega o teu veredicto deste vinho para ver o que o grupo achou.",
    "together.group.hintBlind": "Depois da revelação verás o que o grupo achou.",
    "together.group.quote": "«{quote}»",
    "together.quote.label": "Diz algo ao grupo",
    "together.quote.hint":
      "Opcional, até {max} caracteres. O grupo vê isto junto ao teu veredicto; nunca é tirado da tua nota privada.",
    "together.quote.placeholder": "Por exemplo: rosas, alcatrão, final longo",
    "together.quote.count": "{n} de {max}",
    "together.choice.label": "Como provas?",
    "together.choice.solo": "Sozinho",
    "together.choice.group": "Em grupo",
    "together.choice.soloHint": "Só tu: ninguém vê o que provas.",
    "together.choice.groupHint":
      "Convide pessoas ou partilhe uma ligação; veem as escolhas uns dos outros em direto, se quiseres.",
    "together.tile.hint": "Sozinho ou em grupo",
    "together.planned.eyebrow": "Planeado com amigos",
    "together.planned.live": "A decorrer",
    "together.planned.going": "{n} vão",
    "together.planned.open": "Abrir {name}",
    "together.planned.join": "Ir para a prova",
  },
} as const;
